/**
 * Settings -> Profile: the language of the dashboard + portal mails
 * (OCP-656). Same persistence path as the navbar toggle.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LOCALE_LABELS, SUPPORTED_LOCALES, applyLocale, currentLocale, isPortalLocale } from '../i18n';
import { useOptionalAuth } from '../lib/auth-context';
import { usePortalConfig } from '../lib/portal-config';

export function LanguageSection() {
  const { t } = useTranslation('common');
  const auth = useOptionalAuth();
  const { localesEnabled } = usePortalConfig();
  const setLocale = auth?.setLocale ?? applyLocale;
  const [note, setNote] = useState<'saved' | 'failed' | null>(null);
  const active = currentLocale();
  if (!localesEnabled) return null;
  return (
    <section className="rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4" data-testid="language-section">
      <h2 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{t('language.title')}</h2>
      <p className="mt-1 text-xs text-gray-500">{t('language.help')}</p>
      <select
        aria-label={t('language.title')}
        value={active}
        onChange={(e) => {
          const v = e.target.value;
          if (!isPortalLocale(v)) return;
          setNote(null);
          setLocale(v).then(
            () => setNote('saved'),
            () => setNote('failed'),
          );
        }}
        className="mt-3 rounded border border-gray-300 dark:border-gray-700 bg-transparent px-2 py-1 text-sm"
      >
        {SUPPORTED_LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_LABELS[code]}
          </option>
        ))}
      </select>
      {note === 'saved' && <p className="mt-2 text-xs text-emerald-600">{t('language.saved')}</p>}
      {note === 'failed' && <p className="mt-2 text-xs text-red-600">{t('language.saveFailed')}</p>}
    </section>
  );
}
